module.exports = __webpack_public_path__ + "img/qa.98b79a37.svg";